import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Container,
  CssBaseline,
  Typography,
  Button,
  CardMedia,
} from "../../components/shared/MaterialUI";

import { useHistory } from "react-router-dom";
import { useUI } from "../../app/context/ui";
import logo from "../../assets/images/login-logo.png";
import ExternalCalendarService from "../../services/ExternalCalendarService";
import { InputField } from "../../forms";
import { FormatAccountNumber } from "../../helpers";
import {LoginStyles} from '../../assets/css';
import {connect} from "react-redux";
import {addUser, removeUser} from "../../redux/actions/user";

const externalCalendarService = new ExternalCalendarService();

const ExternalAccountNumber = (props) => {

  const [hasError, setHasError] = useState({});
  const [requestFailed, setRequestFailed] = useState(false);
  const loginStyle = LoginStyles();
  const { blockUI } = useUI();
  const history = useHistory();

  useEffect(() => {
    if (!setRequestFailed) {
      setHasError("");
    }
  }, [requestFailed]);

  useEffect(() => {
    props.dispatch(removeUser());
  }, [props.dispatch]);

  const ExternalCalendarSchema = Yup.object().shape({
    account_number: Yup.string()
      .required('Account number is required')
      .min(4, 'Account number must be at least 4 characters'),
  });

  const onSubmit = async (values) => {
    blockUI.current.open(true);
    setRequestFailed(false);

    try {
      const { data } = await externalCalendarService.searchAccountNumber(values);
      const accessToken = data?.token?.accessToken;

      if (!accessToken) {
        throw new Error("Access token is not available.");
      }

      const payload = { ...data, accessToken };
      props.dispatch(addUser(payload));
      history.push("/web/account/payment-list", { ...data });
    } catch (e) {
      const errorMsg = e?.response?.data?.message || "An unexpected error occurred.";
      setRequestFailed(true);
      setHasError({ message: errorMsg });
    } finally {
      blockUI.current.open(false);
    }
  };


  return (
    <Container component="main" maxWidth="lg" className={loginStyle.bgMain}>
      <Typography component="div" className={loginStyle.panForm} style={{width: '90%'}}>
        <CssBaseline />
        <Typography component="div" className={loginStyle.alignItemsAndJustifyContent}>
          <CardMedia
            className={loginStyle.cardLogo}
            component="img"
            image={logo}
            title="Mow Manager"
          />
        </Typography>
        <Typography component="div">
          {requestFailed && (
            <p className={loginStyle.formError}>{hasError.message}</p>
          )}
        </Typography>

        <Formik
          initialValues={{
            account_number: "",
          }}
          onSubmit={(values,{resetForm}) => {
            onSubmit(values, resetForm);
          }}
          validationSchema={ExternalCalendarSchema}
        >
          {() => {
            return (
              <Form className={loginStyle.formMain} style={{top: '90px'}}>
                <InputField
                  name={'account_number'}
                  InputProps={{inputComponent: FormatAccountNumber}}
                  placeholder="Enter your account number here"
                  autoComplete="off"
                  fullWidth
                  style={{marginTop: '53px'}}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classNames(loginStyle.btnSubmit, loginStyle.btnSendReset)}
                  style={{marginTop: '36px', marginBottom: '22px'}}
                >
                  Continue
                </Button>
              </Form>
            );
          }}
        </Formik>
      </Typography>
    </Container>
  );
};

export default connect(null)(ExternalAccountNumber);
